import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';

export let resetConnectBasicStore = mutatorAction('initConnectBasicStore', () => {
    let store = connectedAccountsStore();
    store.connectBasicState.displayName = '';
    store.connectBasicState.emailAddress = '';
    store.connectBasicState.password = '';
    store.connectBasicState.useNewFolder = true;
    store.connectBasicState.isConnecting = false;
    store.connectBasicState.advancedChecked = false;
});
